import { getSelectedFiltersCountFromMap, getStartTSEndTSFromDateFilters } from 'screens/Team/TeamPageFilters/helper';

import { TASK_TYPES_2 } from 'constants/ProjectConstants';
import { localStorageKeys } from 'constants/localStorageKeys';

import { getStartEndTimeFromDurationKey } from 'services/helpers/task';

export const getLocalStorageStatsFilters = (type) => {
  const key =
    type === TASK_TYPES_2.goal
      ? localStorageKeys.teamPageGoalsStatsFilters
      : localStorageKeys.teamPageTasksStatsFilters;
  const val = localStorage.getItem(key);

  return (val && JSON.parse(val)) || null;
};

export const getCompletedOnDurationFromFilters = (newFiltersState) => {
  const selectedCompletedFiltersCount = getSelectedFiltersCountFromMap(newFiltersState?.completedOnFilters);
  return selectedCompletedFiltersCount > 0
    ? getStartTSEndTSFromDateFilters(newFiltersState.completedOnFilters)
    : getStartEndTimeFromDurationKey('LASTYEAR');
};

export const getTimeBoundsFromLS = () => {
  try {
    const timeBounds = JSON.parse(window.localStorage.getItem(localStorageKeys.teamPageGoalsTimeBounds));
    return timeBounds || [];
  } catch (e) {
    console.error('Error in reading LS: ', e);
  }
};

const setTimeBoundsToLS = (timeBounds) => {
  try {
    window.localStorage.setItem(localStorageKeys.teamPageGoalsTimeBounds, JSON.stringify(timeBounds));
  } catch (e) {
    console.error('Error in saving to LS: ', e);
  }
};
